export enum UserScheduleConfigured {
  Configured = 1,
  NotConfigured = 2,
  Expired = 3
}
